/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Preview_Why_AsksInputs */

const en_us2_search_preview_why_asks = /** @type {(inputs: Search_Preview_Why_AsksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why we ask`)
};

const pt_br2_search_preview_why_asks = /** @type {(inputs: Search_Preview_Why_AsksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que perguntamos`)
};

const es_419_search_preview_why_asks = /** @type {(inputs: Search_Preview_Why_AsksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por qué lo preguntamos`)
};

const pt_pt2_search_preview_why_asks = /** @type {(inputs: Search_Preview_Why_AsksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque perguntamos`)
};

const fr_fr2_search_preview_why_asks = /** @type {(inputs: Search_Preview_Why_AsksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi on le demande`)
};

const de_de2_search_preview_why_asks = /** @type {(inputs: Search_Preview_Why_AsksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum wir fragen`)
};

const it_it2_search_preview_why_asks = /** @type {(inputs: Search_Preview_Why_AsksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché lo chiediamo`)
};

/**
* | output |
* | --- |
* | "Why we ask" |
*
* @param {Search_Preview_Why_AsksInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_preview_why_asks = /** @type {((inputs?: Search_Preview_Why_AsksInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Preview_Why_AsksInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_preview_why_asks(inputs)
	if (locale === "es-419") return es_419_search_preview_why_asks(inputs)
	if (locale === "pt-PT") return pt_pt2_search_preview_why_asks(inputs)
	if (locale === "fr-FR") return fr_fr2_search_preview_why_asks(inputs)
	if (locale === "de-DE") return de_de2_search_preview_why_asks(inputs)
	if (locale === "it-IT") return it_it2_search_preview_why_asks(inputs)
	return en_us2_search_preview_why_asks(inputs)
});
export { search_preview_why_asks as "search.preview_why_asks" }